export default __webpack_public_path__ + "static/media/modern-kitchen-white-table-mug-green-salad@2x.e50959a3.png";